import React, { useState } from "react";
import { usePermissionContext } from "../../contexts/permission-context";
import { getCompanyId, getToken, getUser,copyToClipboard, allPermissionOptions, hasPermission } from '../../Utils/Common';
import axios from 'axios';
import Button from "@mui/material/Button";
import CopyIcon from '@mui/icons-material/AddToPhotosOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from '@mui/icons-material/Info';
import NumberInputSpinner from "../../components/NumberInputSpinner/NumberInputSpinner";
import './system.scss';

const SystemMiscellaneousTabPanel = () => {
    const { permissions } = usePermissionContext();
    const [token, setToken] = useState("");
    const [filterLimit, setFilterLimit] = useState(1);
    const fetchData = async () => {
        let hr = Number(filterLimit);
        const apiURL = `/api/token/jwt?hour=${hr}`;
        axios({
            method: "get", url: apiURL,
            headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
        })
            .then(response => {
                const data = response.data;
                setToken(data);
            }).catch(error => {
                console.log('error in api call:', error);
            });

    }

    const onFilterLimitChanged = (value) => {
        setFilterLimit(value);
    };

    const instructions = "A CDV Token will provide secure access up to the selected hours.";

    return (
        <>
            <div id="miscContainer" style={{ marginTop: '0px' }}>
                <div className="miscPanel">
                    <h4 className="miscPanelTitle">CDV Token <Tooltip title={instructions} arrow placement="top">
                            <InfoIcon style={{ verticalAlign: 'middle', marginLeft: '5px' }} />
                        </Tooltip></h4>
                    <div className="miscPanelContent">
                    {/* <label className="miscLabel">Select Hours: <input type="number" id="hour" name="hour" min="1" max="24" value={hour} onChange={handleChange}></input></label> */}
                    <label className="miscLabel">Select Hours:</label>
                    <NumberInputSpinner className="inputSpinnerContainer" name="limitMisc" min={1} max={24} defaultValue={0} value={filterLimit} onChange={onFilterLimitChanged} />
                    {hasPermission(permissions, allPermissionOptions) && (
                    <Button variant='contained' size="small" onClick={fetchData}
                        sx={{
                            lineHeight: 'normal',
                            textTransform: 'none',
                            background: '#82C027',
                            color: '#333330',
                            '&:hover': {
                                backgroundColor: '#82C027',
                                boxShadow: 'none',
                            }
                        }}>GET CDV token</Button>
                    )}
                    </div>
                </div>
                <div className="miscCopyContent">
                    {/* <textarea value={token} rows="6" className="miscContainer-text"></textarea> */}
                    <div>{token}</div>
                    <Tooltip title="Copy to clipboard" arrow placement="right">
                          <IconButton aria-label="copy group ID" onClick={(event) => copyToClipboard(event, token)}>
                            <CopyIcon sx={{ fontSize: 'small' }} />
                          </IconButton>
                    </Tooltip>
                </div>
            </div>

        </>
    );
}

export default SystemMiscellaneousTabPanel;